var styleDataHash = "985a13f0";
const injectCss = () => {
  var css = `.BgQnC{margin-left:0;margin-right:auto;z-index:1}.BgQnC:not(.g2Ab2){float:left;margin-right:40px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.BgQnC:not(.g2Ab2){float:none;margin-right:auto}}}@container (width < 640px){.BgQnC:not(.g2Ab2){float:none;margin-right:auto}}.SE5ZB{margin-left:auto;margin-right:0;z-index:1}.SE5ZB:not(.g2Ab2){float:right;margin-left:40px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.SE5ZB:not(.g2Ab2){float:none;margin-left:auto}}}@container (width < 640px){.SE5ZB:not(.g2Ab2){float:none;margin-left:auto}}.z6HIs{clear:both;display:block}.z6HIs:not(.EZTmf){margin-left:auto;margin-right:auto;max-width:100%}.EZTmf,.g2Ab2{width:100%}.UKxBH .EZTmf,.UKxBH .g2Ab2{margin:0 -8px;width:auto}.fBXlf{width:fit-content}._2jEwg{margin-left:auto;margin-right:auto;max-width:100%}._2P4mk{width:min(350px,100%)!important}.UKxBH ._2P4mk{width:50%}.uFmJw{margin-left:auto;margin-right:auto}.UKxBH .uFmJw{width:150px}.LmDcC{display:flex}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var general_rtlignore_default = {
  "alignLeft": "BgQnC",
  "textWrapNowrap": "g2Ab2",
  "alignRight": "SE5ZB",
  "alignCenter": "z6HIs",
  "sizeFullWidth": "EZTmf",
  "renderedInTable": "UKxBH",
  "sizeOriginal": "fBXlf",
  "sizeContent": "_2jEwg",
  "sizeSmall": "_2P4mk",
  "sizeSmallCenter": "uFmJw",
  "flex": "LmDcC"
};
export {
  general_rtlignore_default as default,
  injectCss
};
//# sourceMappingURL=general.rtlignore-scss.js.map
